export default __webpack_public_path__ + "b5d2b55de25a85537b420db49eb267fd.svg";